import { FieldType } from "../types/api.js";
import { bnOrZero } from "./number.js";
import moment from "moment";
const convertListResult = (result, spec) => {
  var _a;
  const entries = (_a = result == null ? void 0 : result.entries) == null ? void 0 : _a.map((model) => convert(spec, model));
  return {
    ...result,
    entries
    // models,
  };
};
const convertObjectResult = (result, spec) => {
  const model = convert(spec, result == null ? void 0 : result.model);
  return {
    ...result,
    model
  };
};
const convertAnyResult = (result, spec) => {
  if (!spec) return result;
  const model = convert(spec, result);
  return {
    ...result,
    ...model
  };
};
const convert = (spec, data) => {
  if (data === null || data === void 0) return data;
  const output = { ...data };
  for (const key in spec) {
    const fieldSpec = spec[key];
    const value = output[key];
    switch (fieldSpec) {
      case FieldType.DateTime: {
        if (typeof value === "string") {
          output[key] = moment(value);
        } else if (typeof value === "number") {
          output[key] = moment.unix(value);
        }
        break;
      }
      case FieldType.Number: {
        if (typeof value === "string") {
          const n = parseFloat(value);
          if (isFinite(n) && !isNaN(n)) {
            output[key] = n;
          }
        }
        break;
      }
      case FieldType.BigNumber:
        {
          if (value !== null && value !== void 0) output[key] = bnOrZero(value);
        }
        break;
      default:
        if (Array.isArray(value)) {
          output[key] = value.map((v) => convert(fieldSpec, v));
          break;
        }
        if (typeof fieldSpec === "object") {
          output[key] = convert(fieldSpec, value);
        }
        break;
    }
  }
  return output;
};
const transformWithSpec = (spec) => {
  return (response) => {
    if (!response.result) {
      return response.result;
    }
    if (!spec || typeof response.result === "boolean") return response.result;
    if ("entries" in response.result || "models" in response.result)
      return convertListResult(response.result, spec);
    if ("model" in response.result) {
      if (Array.isArray(response.result.model)) {
        return convertListResult(response.result, spec);
      }
      return convertObjectResult(response.result, spec);
    }
    return convertAnyResult(response.result, spec);
  };
};
const transformListWithSpec = (spec) => {
  return (response) => convertListResult(response.result, spec);
};
const transformObjectWithSpec = (spec) => {
  return (response) => convertObjectResult(response.result, spec);
};
const transformAnyWithSpec = (spec) => {
  return (response) => convertAnyResult(response.result, spec);
};
const transformAccessToken = (input) => {
  return {
    token_type: input.token_type,
    access_token: input.access_token,
    refresh_token: input.refresh_token,
    expires_at: input.expires_at,
    refresh_expires_at: input.refresh_expires_at,
    expires_in: input.expires_in,
    refresh_expires_in: input.refresh_expires_in
  };
};
export {
  convert,
  convertAnyResult,
  convertListResult,
  convertObjectResult,
  transformAccessToken,
  transformAnyWithSpec,
  transformListWithSpec,
  transformObjectWithSpec,
  transformWithSpec
};
